import React from 'react';
import { titleCase } from 'utils/text';
import { hasResource } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';

export interface DealerVersionLabelProps {
  dealerName: string;
  dealerVersion?: number | string | null;
  dealerStatus?: string | null;
  /**
   * Permission key for showing "- v1/v2" suffix.
   * Controlled via `hasResource(resourceIdentifier)`.
   */
  resourceIdentifier?: string;
}

const getNormalizedVersion = (version?: number | string | null): 1 | 2 | null => {
  if (version === null || version === undefined) return null;
  const normalized = Number(version);
  if (normalized === 1) return 1;
  if (normalized === 2) return 2;
  return null;
};

export const DealerVersionLabel: React.FC<DealerVersionLabelProps> = ({
  dealerName,
  dealerVersion,
  dealerStatus,
  resourceIdentifier = 'DealerVersionLabel',
}) => {
  const canSeeVersion = hasResource(resourceIdentifier);
  const normalizedVersion = getNormalizedVersion(dealerVersion);

  const statusSuffix =
    dealerStatus && dealerStatus !== 'ACTIVE' ? ` (${titleCase(dealerStatus)})` : '';

  return (
    <>
      {dealerName}
      {canSeeVersion && normalizedVersion ? ` - v${normalizedVersion}` : ''}
      {statusSuffix}
    </>
  );
};

